<script setup>
import { computed } from "vue"
import Event from "./Event.vue"
import MoreLink from "../components/MoreLink"
import { useFilteredFeedStore } from "../utils/store.js"

const store = useFilteredFeedStore()

const getComponentName = computed( () => {
	return {
		'event' : Event
	}[store.endpoint]
})

defineProps({
	wrapClass: {
		type: String,
		required: false,
	},
	title: {
		type: String,
		required: false,
	},
	items: {
		type: Array,
		required: true,
	},
	isFeatured: {
		type: Boolean,
		required: false,
		default: () => {
			return false
		},
	},
	pagination: {
		type: Boolean,
		required: false,
		default: () => {
			return true
		},
	},
})
</script>

<template>
	<div class="theme-default">
		<div class="grid md:grid-cols-3 gap-8 md:gap-4">
			<TransitionGroup>
				<component :is="getComponentName" 
					v-for="(item, index) in store.items"
					:item="item"
					:key="item.id" 
					:base-url="store.whatsOnBaseURL"
					/>
			</TransitionGroup>
		</div>
		<MoreLink v-if="store.hasMorePages" />
	</div>
</template>